import React from 'react'
import  {Hero ,CountupCard ,AboutUs, Services,Reviews,Fotter ,Blogs, TimeLine} from '../components'
import { Header } from '../components/layout'
import CategoriesSection from '../components/Home/CategoriesSection'
import FeaturedMealSections from '../components/Home/FeaturedMealSections'


function Home() {
  return (
<> <Header active={1} />

         <Hero  />
  <CategoriesSection />
       <FeaturedMealSections/>
 <Reviews/>
          <Fotter />

</>
    
       
   
  )
}

export default Home